var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettingsNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8401 24.2423C62.0591 23.4613 60.7927 23.4613 60.0117 24.2423L38.5411 45.7129L28.0706 35.2423C27.2895 34.4613 26.0232 34.4613 25.2422 35.2423C24.4611 36.0234 24.4611 37.2897 25.2422 38.0708L37.1253 49.9539C37.8089 50.6375 38.8685 50.7242 39.6446 50.2076L39.6495 50.2043C39.7591 50.1318 39.8644 50.0465 39.9635 49.9474L62.8401 27.0708C63.6212 26.2897 63.6212 25.0234 62.8401 24.2423ZM57.1833 21.4139C59.5264 19.0708 63.3254 19.0708 65.6686 21.4139C68.0117 23.7571 68.0117 27.5561 65.6685 29.8992L42.7919 52.7758C42.5028 53.065 42.1899 53.3196 41.8588 53.5389C39.5276 55.089 36.3535 54.839 34.2969 52.7823L22.4137 40.8992C20.0706 38.5561 20.0706 34.7571 22.4137 32.4139C24.7569 30.0708 28.5559 30.0708 30.899 32.4139L38.5411 40.056L57.1833 21.4139Z",
    fill: "#15D4B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9995 11.9997C24.5355 11.9997 11.9995 24.5357 11.9995 39.9997C11.9995 55.4637 24.5355 67.9997 39.9995 67.9997C55.4635 67.9997 67.9995 55.4637 67.9995 39.9997C67.9995 38.159 67.8222 36.3617 67.4842 34.6232C67.2734 33.539 67.9815 32.4891 69.0658 32.2783C70.1501 32.0676 71.1999 32.7757 71.4107 33.8599C71.7973 35.8485 71.9995 37.9015 71.9995 39.9997C71.9995 57.6728 57.6726 71.9997 39.9995 71.9997C22.3264 71.9997 7.99951 57.6728 7.99951 39.9997C7.99951 22.3266 22.3264 7.99969 39.9995 7.99969C46.5393 7.99969 52.6264 9.9636 57.6958 13.3342C58.6157 13.9458 58.8655 15.1872 58.254 16.107C57.6424 17.0269 56.401 17.2767 55.4811 16.6652C51.0475 13.7173 45.7272 11.9997 39.9995 11.9997Z",
    fill: "#15D4B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettingsNotify);
export default __webpack_public_path__ + "static/media/iconSettingsNotify.2c12aa867e56bd421e3c27d8fe348ab2.svg";
export { ForwardRef as ReactComponent };